import { Link } from "react-router-dom";
import { useState } from "react";

const Pagination = ({ pagination }) => {
  const totalPages = pagination?.total || 0;
  const currentPage = pagination?.page || 1;
  const setPage = pagination?.setPage;

  const [inputValue, setInputValue] = useState("");

  const visiblePages = 5;

  const getPageNumbers = () => {
    if (totalPages <= visiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [1];

    if (currentPage > 4) pages.push("...");

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 3) pages.push("...");
    if (currentPage < totalPages - 2) pages.push(totalPages);

    return pages;
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    const pageNum = parseInt(inputValue);
    if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
    setInputValue(""); // Clear input after submit
  };

  return (
    <div
      className="d-flex mt-3 mb-2 align-items-center gap-3"
      style={{ justifyContent: "right", userSelect: "none" }}
    >
      <ul className="pagination pagination-separated pagination-md mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <Link
            to="#"
            className="page-link"
            onClick={() => setPage(currentPage - 1)}
          >
            &laquo;
          </Link>
        </li>

        {getPageNumbers().map((page, index) =>
          page === "..." ? (
            <li className="page-item disabled" key={index}>
              <span className="page-link">...</span>
            </li>
          ) : (
            <li
              className={`page-item ${currentPage === page ? "active" : ""}`}
              key={index}
            >
              <Link to="#" className="page-link" onClick={() => setPage(page)}>
                {page}
              </Link>
            </li>
          )
        )}

        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <Link
            to="#"
            className="page-link"
            onClick={() => setPage(currentPage + 1)}
          >
            &raquo;
          </Link>
        </li>
      </ul>

      <form onSubmit={handleInputSubmit}>
        <div
          className="input-group input-group-sm"
          style={{ width: 100, height: "32px", borderRadius: "10px" }}
        >
          <input
            type="number"
            min="1"
            max={totalPages}
            className="form-control"
            placeholder="Go to"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          <button className="btn btn-outline-secondary" type="submit">
            Go
          </button>
        </div>
      </form>
    </div>
  );
};

export default Pagination;
